<template>
    <div :ref="stepName" style="position:relative">
        <div class="form-header">
            <p>Merci !<br>
                Nous demandons un dernier effort, veuillez confirmer toutes vos coordonnées ici :</p>
        </div>
        <div class="coreg-recap">
            <p class="recap-label" v-if="lastname">Nom </p>
            <p v-if="lastname"><span v-if="gender" v-html="gender=='m'? _.toUpper('M') : _.toUpper('Mme')"></span> <span>{{_.toUpper(lastname)}}</span></p>

            <p class="recap-label" v-if="firstname">Prénom </p>
            <p v-if="firstname"> <span>{{_.toUpper(firstname)}}</span></p>

            <p class="recap-label" v-if="email">Email </p>
            <p v-if="email"><span>{{_.toUpper(email)}}</span></p>
        </div>

        <a class="correction-link" :disabled="block_form" @click.prevent="goTo('gender')">
            Modifier mes coordonnées
        </a>


        <b-button type="button next-button is-primary" :disabled="block_form" v-html="step._button" @click="nextStep()"></b-button>

        <b-loading :is-full-page="false" v-model="loading"></b-loading>
    </div>
</template>

<script>
import mixin from "../../../travel_step_mixin";
import animation_engine_mixin from "../../../animation_engine_mixin";
import animation_step_style_mixin from "../../../animation_step_style_mixin";
import {get} from 'vuex-pathify';

export default {
    mixins: [mixin, animation_engine_mixin, animation_step_style_mixin],
    computed: {
        ...get('form_data', ['gender','lastname','firstname','email'])
    },
}
</script>
